var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"mb-2",attrs:{"no-gutters":""}},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.title))]),_vm._v(": "+_vm._s(_vm.val)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }